<template>
  <div class="relative" :class="marginClass">
    <div
      v-if="src"
      :class="['rounded-full bg-no-repeat bg-cover bg-center', sizeClass]"
      :style="{ backgroundImage: `url(${src})` }"
    ></div>
    <div
      v-else
      :class="[
        'bg-[#014451] text-uppercase flex items-center justify-center text-lg rounded-full text-white',
        sizeClass
      ]"
    >
      {{ initials }}
    </div>
    <span
      v-if="statusClass && timeCardsEnabled"
      class="clocked-in-status-icon absolute w-3.5 h-3.5 border-2 border-white dark:border-gray-800 rounded-full"
      :class="statusClass"
    ></span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = withDefaults(
  defineProps<{
    src?: string;
    alt?: string;
    status?: string;
    marginClass?: string;
    initials?: string;
    sizeClass?: string;
  }>(),
  {
    src: "",
    alt: "",
    status: "",
    marginClass: "",
    initials: "",
    sizeClass: "w-10 h-10"
  }
);
const statusClass = computed(() => {
  if (props.status === "online") {
    return "top-0 start-7 bg-green-500";
  }
  if (props.status === "offline") {
    return "top-0 start-7 bg-red-500";
  }
  return "";
});

const timeCardsEnabled = computed(() => store.state.tenant?.time_cards_enabled);
</script>
